<template>
    <div>
        <div class="dropdown">
            <button aria-expanded="false" class="btn bg-white d-flex justify-content-between align-items-center dropdown-toggle w-100" 
            :class=" provider.getConfig('dropdownFilterClass')"
            data-bs-toggle="dropdown"
                    type="button">
                {{ provider.getConfig('label_' + filterName + '_filter') }}
            </button>
            <ul class="dropdown-menu">
                <li v-for="{value, isSelected} in filters">
                    <a class="dropdown-item"
                       :class="{active: isSelected}"
                       href="#" @click.prevent="provider.toggleFilter(filterName, value)"
                    >
                        {{ value }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script lang="ts" setup>
import {inject, ref} from "vue";
import type JobApiProvider from "../JobApiProvider.ts";
import {KeyJobApiProvider} from "../symbols.ts";

interface PropsType {
    filterName: string
}

const props = defineProps<PropsType>();

const provider = inject<JobApiProvider>(KeyJobApiProvider) as JobApiProvider;

const filters = provider.filter(props.filterName);

</script>
